import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/_public/appointments")({
  // beforeLoad: ({ context, location }) => {
  //   if (!context.auth.user) {
  //     throw redirect({
  //       to: '/',
  //       search: {
  //         redirect: location.href,
  //       },
  //     })
  //   }

  //   return {
  //     user: context.auth.user,
  //   }
  // },
  component: () => <Outlet />,
  errorComponent: ({ error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Appointments Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
